import React,
{
    useCallback,
    useEffect,
    useState
} from 'react';
import { Divider } from 'antd';
import { useAppDispatch, useAppSelector } from '../../../hooks/redux';
import {
    searchTagsAction,
} from '../../../redux/actions/tagActions';
import { TableData } from '../../../models/tableData/types';
import { grayDark06 } from '../../../styles/colors';
import { TagsSectionSpinner } from './TagsSection.styles';
import CreateTag from '../CreateTag/CreateTag';
import TagsGroupBox from '../TagsGroupBox/TagsGroupBox';
import TagsTable from '../TagsTable/TagsTable';
import { usePermissions } from '../../../hooks/permissions';
import { AccountPermissionTypes } from '../../../models/permission/enums';
import { getColorsAction } from '../../../redux/actions/colorsActions';


const TagsSection: React.FC = () => {
    const [selectedTagIds, setSelectedTagIds] = useState<number[]>([]);
    const { pending, totalCount } = useAppSelector((state) => state.tagReducer);
    const [tableData, setTableData] = useState<TableData>({
        curPage: 1,
        pageSize: 10,
        searchString: '',
        sortDirection: 'asc',
        sortExpression: null,
    });
    const { getAccountRole } = usePermissions();
    const dispatch = useAppDispatch();

    useEffect(() => {
        dispatch(getColorsAction());
    }, []);

    const fetchTags = useCallback(async (data: TableData) => {
        await dispatch(
            searchTagsAction({
                curPage: data.curPage,
                pageSize: data.pageSize,
                searchString: data.searchString,
                sortExpression: (data.sortExpression as string) ?? null,
                sortDirection: (data.sortDirection as string) ?? 'asc',
                extraInfo: true,
            }),
        );
    }, [dispatch]);

    useEffect(() => {
        fetchTags(tableData);
    }, []);

    const canCreateUpdateDeleteTag = getAccountRole() === AccountPermissionTypes.ACCOUNT_ADMIN;

    return (
        <TagsGroupBox>
            <TagsSectionSpinner size="large" spinning={pending}>
                {canCreateUpdateDeleteTag && <CreateTag fetchTags={fetchTags} tableData={tableData} />}
                {canCreateUpdateDeleteTag && <Divider style={{ marginTop: '32px', marginBottom: '32px', borderColor: grayDark06 }} />}
                <TagsTable
                    tableData={tableData}
                    totalCount={totalCount}
                    setSelectedTagIds={setSelectedTagIds}
                    setTableData={setTableData}
                    selectedTagIds={selectedTagIds}
                    fetchTags={fetchTags}
                />
            </TagsSectionSpinner>
        </TagsGroupBox>
    );
};

export default TagsSection;